var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"view form-view",attrs:{"id":"vehicle-edit-view"}},[_vm._m(0),_c('vehicle-create-from',{attrs:{"fleet-uuid":this.$route.params.fleetUuid}})],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"form-box"},[_c('h2',[_vm._v("Create vehicle")])])
}]

export { render, staticRenderFns }